<div class="modal-content m-0">
  <div class="modal-header">
    <p class="mb-0">{{ 'reports.upload.title' | translate }}</p>
    <i class="fa-light fa-xmark ms-auto cursor-pointer" (click)="dismiss()"></i>
  </div>
  <div class="modal-body">
    <div class="form-group col-sm-12">
      <form [formGroup]="form" novalidate>
        <div class="form-group form-group-file">
          <label class="form-label" tabindex="1">{{
            'reports.upload.file' | translate
          }}</label>
          <input
            type="file"
            id="file_upload"
            name="file_upload"
            class="file-input d-none"
            multiple
            accept="application/msword, application/vnd.openxmlformats-officedocument.wordprocessingml.document, application/pdf"
            (change)="onFileChange($event)"
          />
          <label for="file_upload" class="form-control">
            <span>
              @if (!filesToProcess) {
                <span translate="common.noFilesSelected">
                  <span class="text-danger fw-bold">&nbsp;*</span>
                </span>
              } @else {
                <span>{{ filesToProcess.length }} file(s)</span>
              }
            </span>
            <label
              for="file_upload"
              class="btn btn-primary"
              translate="common.pickFiles"
            ></label>
          </label>
          <small class="form-text text-muted">
            <small class="float-end d-block d-md-inline">
              &nbsp;&nbsp;{{ 'common.supportedFormats' | translate }}
              &nbsp; *.doc, *.docx, *.pdf
            </small>
          </small>
        </div>
        <div class="form-group">
          <label class="form-label" tabindex="1">{{
            'reports.upload.signee' | translate
          }}</label>
          <app-select
            id="signeeId"
            [placeholder]="'Select person'"
            formControlName="signeeId"
          >
            @for ((signee of signees$ | async); track signee.id) {
              <app-select-option [value]="signee.id" [label]="signee.name" />
            }
          </app-select>
        </div>
        <div class="row">
          <div class="col-12">
            <app-data-table
              [configuration]="dataTableConfiguration"
            ></app-data-table>
          </div>
        </div>
      </form>
    </div>
  </div>
  <div class="modal-footer">
    <button
      class="btn btn-primary"
      [disabled]="!filesToProcess || form.invalid"
      (click)="upload($event)"
    >
      {{ 'dashboardPage.buttons.upload' | translate }}
    </button>
  </div>
</div>
